import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { RolesSharedService } from "./../../services/roles-shared.service";
import { Component, OnInit, Inject, ViewChild, OnDestroy } from "@angular/core";
import { Constants } from "@app/shared/constants/app.constants";
import { DOCUMENT } from "@angular/common";
import { Paginator } from "primeng/paginator";
import { FutureResearchSort } from "@app/shared/constants/app.constants";
import { AuthenticationService } from "@app/shared/services/authentication.service";
import { Router, ActivatedRoute } from "@angular/router";
import { TechBuyerService } from "@app/feature/main/tech-buyer/shared/services/tech-buyer.service";
import { NickNameModalService } from "@app/feature/main/roles-shared/services/nick-name-modal.service";
import { LikeModalServiceService } from "@app/shared/services/like-modal-service.service";
import { CommentModalService } from "@app/shared/services/comment-modal.service";
import { Subscription } from "rxjs/Subscription";
import { TechDomainService } from "@app/shared/services/tech-domain.service";
declare var $: any;
@Component({
  selector: "app-future-research",
  templateUrl: "./future-research.component.html",
  styleUrls: ["./future-research.component.css"]
})
export class FutureResearchComponent implements OnInit, OnDestroy {
  @ViewChild('paginatorId') paginator = new Paginator();
  userDetailsObject;
  futureData: object;
  addCommentForm: FormGroup;
  moreCommentsLimit = 5;
  moreCommentsSkip = 5;
  userRole;
  techDomainListData: any;
  loggedInStatus;
  userId = "";
  hasCompanyDetails = false;
  analystData;
  noResearchData: boolean;
  scrollId: any;
  techDomainListselected: string;
  sortListData: any;
  subscription: Subscription;

  // search
  searchKeyword = "";
  selectedDomain = "";
  searchString = "";
  sortSelectedindex = null;
  techDomainData;

  // Filter
  totalRecords = 0;
  dataLimit = 9;
  skipValue = 0;

  constructor(
    public rolesSharedService: RolesSharedService,
    private formBuilder: FormBuilder,
    private authenticationService: AuthenticationService,
    private router: Router,
    private techBuyerService: TechBuyerService,
    private nickNameModalService: NickNameModalService,
    private activatedRoute: ActivatedRoute,
    private likeModalService: LikeModalServiceService,
    private commentModalService: CommentModalService,
    @Inject(DOCUMENT) private document: Document,
    private techDomainService: TechDomainService
  ) {
    this.document.body.classList.add("inner-page");
    this.document.body.classList.remove("outer-page");
   // window.scroll(0, 0);
  }

  ngOnInit() {
    this.getParams();
    this.userDetails();
    this.getRole();
    this.analystDatafunc();
    this.getDomainList();
    this.techDomainListselected = window.localStorage.getItem('selectedTechDomainId') ?
      window.localStorage.getItem('selectedTechDomainId') : null;
    this.sortListData = FutureResearchSort.list;
    this.getFutureResearch();

    this.subscription = this.techDomainService.selectedDomainId.subscribe(
      (newSelectedIds) => {
        this.userDetails();
        if(this.loggedInStatus){
          this.techDomainListselected = newSelectedIds;
          this.applyFilter();
        }
    });
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  getParams() {
    this.scrollId = this.activatedRoute.snapshot.queryParams.researchDocId;

  }

  analystDatafunc() {
    const analystListFilter: any = {};
    analystListFilter.filter = JSON.stringify({
      limit: 10,
      skip: 0
    });
    this.rolesSharedService
      .getAnalystListDetails(analystListFilter)
      .subscribe((analystList: any) => {
        this.analystData = analystList;
      });
  }

  userDetails() {
    if (window.sessionStorage.getItem("userDetails") != null && window.sessionStorage.getItem("userDetails") != "null") {
      this.userDetailsObject = JSON.parse(
        window.sessionStorage.getItem("userDetails")
      );
      this.loggedInStatus = true;
      this.userId = this.userDetailsObject.userId;

    } else {
      this.loggedInStatus = false;
    }
  }

  openCommentModal(data) {
    if (this.loggedInStatus && window.sessionStorage.getItem("userDetails") != null && window.sessionStorage.getItem("userDetails") != "null") {
      this.userDetailsObject = JSON.parse(
        window.sessionStorage.getItem("userDetails")
      );
      if (this.loggedInStatus && this.userDetailsObject.nickName) {
        this.commentModalService.modalStatus(true, data);
      }
      else {
        this.nickNameModalService.openNickNameModal();
      }
    }
    else {
      // fix reditect login
      this.router.navigate(["/signin"]);
    }
  }

  getRole() {
    this.userRole = this.authenticationService.getFormattedRole();
  }

  getDomainList() {
    this.rolesSharedService.getTechDomainsList().subscribe(data => {
      this.techDomainListData = data;
    });
  }

  applyFilter() {
    this.dataLimit = 9;
    this.skipValue = 0;
    if (this.paginator) {
      this.paginator.first = 0;
    }
    this.futureData = [];
    this.getFutureResearch();
  }

  getFutureResearch() {
    const filter: any = {};
    filter.filter = JSON.stringify({
      include: [
        {
          relation: "comments",
          scope: {
            include: {
              relation: "user"
            }
          }
        },
        { likes: "user" }
      ]
    });
    filter.limit = this.dataLimit;
    filter.skip = this.skipValue;
    filter.search = this.searchString;
    filter.sort = this.sortSelectedindex ? this.sortSelectedindex : "createdAt DESC";
    if (this.techDomainListselected) {
      filter.techDomainId = this.techDomainListselected;
    }
    this.rolesSharedService.getFutureResearch(filter).subscribe((response: any) => {
      this.futureData = response.data;
      if (response['totalCount'] == 0) {
        this.noResearchData = true;
      } else {
        this.noResearchData = false;
      }
      if (this.scrollId) {
        setTimeout(() => {
          var elmnt = document.getElementById(`Id${this.scrollId}`);
          elmnt.scrollIntoView();
          window.scrollBy(0, -85);
        }, 500);
      }
    });
  }

  followAnalyst(AnalystData, index) {
    const filter: any = {}
    filter.filter = JSON.stringify({
      analystUserId: AnalystData.id,
      followerUserId: this.userId
    })

    this.rolesSharedService.analystFollow(filter.filter).subscribe(
      followResponse => {

        if (followResponse["followed"]) {
          // case when user is liked and updated in server
          AnalystData.isFollow = true;
          AnalystData.followerCount += 1;
        } else if (!followResponse["followed"]) {
          // case when user is not liked and updated in server
          AnalystData.isFollow = false;
          AnalystData.followerCount -= 1;
        }
      });
  }

  openComments(post, index) {
    post.subCommentsOpened = !post.subCommentsOpened;
  }

  openLikeModal(data) {
    if (this.loggedInStatus) {
      this.likeModalService.modalStatus(true, data);
    } else {
      this.router.navigate(["/signin"]);
    }
  }

  trendingResearchRoute() { }

  reportsRoute() { }

  blogsRoute() { }

  vendorAssessmentTool() { }

  trendingResearchListNavigate() {
    this.router.navigate([`${this.userRole}/research/trending-research`]);
  }

  analystListNavigate() {
    this.router.navigate([`${this.userRole}/analyst-list`]);
  }

  reportsNavigate() {
    this.router.navigate([`${this.userRole}/reports`]);
  }

  blogsNavigate() {
    this.router.navigate([`${this.userRole}/blogs`]);
  }

  featureUnderConstructionNavigation() {
    this.router.navigate([`${this.userRole}/under-construction`]);
  }

  isAccessible() {
    if (this.loggedInStatus && this.userRole === "tech-buyer") {
      if (!this.hasCompanyDetails) {
        this.showModal();
      }
    }
  }
  showModal() {
    $("#company-details").modal("show");
  }

  getTechBuyerDetails() {
    this.techBuyerService
      .getTechBuyerDetails(this.userId)
      .subscribe((response: any) => {
        if (response.techbuyerOrganization.length === 0) {
          this.hasCompanyDetails = false;
        } else {
          this.hasCompanyDetails = true;
        }
      });
  }

  refresh(evt: any) {
    this.getTechBuyerDetails();
    $("#company-details").modal("hide");
  }

  likeClick(postData, postNumber: string) {
    if (this.userDetailsObject.nickName) {
      const likeFilter = {
        postId: postData.id,
        postType: "upcoming_research",
        userId: this.userDetailsObject.id
      };

      this.rolesSharedService.addLike(likeFilter).subscribe(likeResponse => {
        if (likeResponse["liked"]) {
          postData.liked = true;
          postData.likes += 1;
          this.rolesSharedService.logLikeInMixpanel(likeFilter.postType, postData.title);
        } else if (!likeResponse["liked"]) {
          postData.liked = false;
          if (postData.likes != 0) {
            postData.likes -= 1;
          }
        }
      })
    } else {
      this.nickNameModalService.openNickNameModal();
      this.nickNameModalService.nickNameDataUpdatedObservable.subscribe((response: any) => {
        if (response) {
          this.userDetails();
        }
      })
    }
  }

  commentFilter(post, limit, skip) {
    if (limit == null) {
      limit = 5;
    }
    if (skip == null) {
      skip = 0;
    }
    let getCommentFilter = {
      where: {
        postId: post.id,
        parentCommentId: null
      },
      include: [
        {
          likes: "user"
        },
        { mentions: "user" },
        {
          replyComments: "user"
        }, "user"
      ],
      limit: limit,
      skip: skip
    };

    return getCommentFilter;
  }

  populateComments(post) {
    if (this.userDetailsObject.nickName) {
      post.showComments = !post.showComments;
    } else {

      this.nickNameModalService.openNickNameModal();
      this.nickNameModalService.nickNameDataUpdatedObservable.subscribe((response: any) => {
        if (response) {
          this.userDetails();
        }
      })
    }
  }

  routeTechAnalystProfilePage(analystId: string,firstName,secondName) {
    sessionStorage.removeItem('sheduleCallUrl');
      sessionStorage.removeItem('sheduleCallLabel');
      sessionStorage.setItem('analystName', firstName+' '+secondName);
    this.router.navigate(['analyst-profile'], { queryParams: { analystId: analystId } })
  }
}



// WEBPACK FOOTER //
// ./src/app/feature/main/roles-shared/components/future-research/future-research.component.ts